import React, {useEffect, useState, useRef} from "react";
import {useLocation, useNavigate} from 'react-router-dom';
import surveyheart1 from '../../../public/images/surveyheart1.png';
import '../css/faq.css';
import down_gray from '../../../public/images/down_gray.svg';
import MaterialButton, {ButtonTypes} from "../../shared/components/MaterialButton";
import Card from '@mui/material/Card';
import form_builder from '../../../public/images/form_builder.svg';
import quiz_builder from '../../../public/images/quiz_builder.svg';
import premium_builder from '../../../public/images/premium_builder.svg';
import dashboard_builder from '../../../public/images/dashboard_builder.svg';
import settings_builder from '../../../public/images/settings_builder.svg';
import collaborator_builder from '../../../public/images/collaborator_builder.svg';
import search_grey from '../../../public/images/search_grey.svg';
import Vector from '../../../public/images/Vector.png';
import link from '../../../public/images/link.svg';
import up_gray from '../../../public/images/up_gray.svg';
import right_path_arrow from '../../../public/images/right_path_arrow.svg';
import ImageViewerComponent from "../../form/components/questions/ImageViewerComponent";
import appStore from "../../app/store/appStore";
import {Provider} from "react-redux";
import SearchBaseComponent from "../../admin/components/SearchBaseComponent";
import {allCategories, searchFaqs, categoryFaqs, FaqsDetailedAnswer} from "../../shared/utils/sash-v2-api";
import {PAGE_HASH_LOCATION} from "../../app/utils/pages";
import {ADMIN_FORM_IDS} from "../../admin/constants";

const Faq = () => {
    const [expanded, setExpanded] = useState([]);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [accordionData, setAccordionData] = useState([]);
    const [isSearchSubmitted, setIsSearchSubmitted] = useState(false);
    const [showStepsSection, setShowStepsSection] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [copyStatus, setCopyStatus] = useState("Copy Link");
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const location = useLocation();
    const [selectedCategoryQuestions, setSelectedCategoryQuestions] = useState([]);
    const [showRightBar, setShowRightBar] = useState(true);
    const [faqId, setFaqId] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedCategoryTitle, setSelectedCategoryTitle] = useState('');
    const debounceTimerRef = useRef(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const idFromURL = queryParams.get("id");
        setFaqId(idFromURL);

        if (idFromURL) {
            const fetchDetailedAnswer = () => {
                const FAQDetailedSuccess = (response) => {
                    if (!response || typeof response !== "object") {
                        return;
                    }

                    if (response.faq._id === idFromURL) {
                        setSelectedQuestion(response.faq);
                    }
                };

                const FAQDetailedFailure = (error) => {
                    console.error(error);
                };

                FaqsDetailedAnswer(idFromURL, FAQDetailedSuccess, FAQDetailedFailure,);
            };

            fetchDetailedAnswer();
            setShowStepsSection(true);
        } else {
            setShowStepsSection(false);
            setSelectedQuestion(null);
        }
    }, [location.search]);


    const handleFetchSuccess = (data) => {
        if (Array.isArray(data.all_Categories)) {
            const updatedAccordionData = data.all_Categories.map(category => ({
                ...category, questions: category.faqs || []
            }));
            setAccordionData(updatedAccordionData);
        } else {
            console.error(data.all_Categories);
        }
    };
    const handleFetchFailure = (err) => {
        console.error("Failed", err);
    };

    useEffect(() => {
        const fetchCategories = () => {
            allCategories({}, (data) => handleFetchSuccess(data), (error) => handleFetchFailure(error));
        };
        fetchCategories();
    }, []);

    const handleAccordionChange = async (index) => {
        const category = accordionData[index];
        const isExpanded = expanded.includes(index);
        if (!isExpanded) {
            categoryFaqs(category.category_name, {}, (response) => {
                if (response?.result === "SUCCESS" && Array.isArray(response.faqs)) {
                    const updatedQuestions = response.faqs.map(faq => ({
                        ...faq, question: faq?.question
                    }));
                    const updatedAccordionData = accordionData.map(apiCategory => apiCategory.category_name === category.category_name ? {
                        ...apiCategory, questions: updatedQuestions
                    } : apiCategory);
                    setAccordionData(updatedAccordionData);
                }
            }, (error) => {
                console.error("API error:", error);
            });
        }
        setExpanded((prevExpanded) => isExpanded ? prevExpanded.filter((i) => i !== index) : [...prevExpanded, index]);
    };

    const handleContactClick = () => {
        window.open(`https://surveyheart.com/form/${ADMIN_FORM_IDS.CONTACT_US}#welcome`, '_blank')
    };

    const handleSubsectionClick = (question) => {
        setSelectedQuestion(question);
        setSearchText("");
        setShowStepsSection(true);
        setIsSearchSubmitted(false);
        window.location.href = PAGE_HASH_LOCATION.faq + `?id=${question._id}`;
    };

    const handleCopyLink = () => {
        if (faqId) {
            const link = `${window.location.origin}${window.location.pathname}#faq?id=${faqId}`;
            navigator.clipboard.writeText(link);
            setCopyStatus("Link Copied");

            setTimeout(() => setCopyStatus("Copy Link"), 2000);
        }
    };


    const handlePopularTopicClick = async (categoryTitle) => {
        const category = accordionData.find((section) => section.category_name === categoryTitle);

        if (category) {
            if (!category.questions || category.questions.length === 0) {
                await categoryFaqs(categoryTitle, {}, (response) => {
                    if (response?.result === "SUCCESS" && Array.isArray(response.faqs)) {
                        const updatedQuestions = response.faqs.map(faq => ({
                            ...faq, question: faq?.question
                        }));
                        const updatedAccordionData = accordionData.map(a => a.category_name === categoryTitle ? {
                            ...a, questions: updatedQuestions
                        } : a);
                        setSelectedCategoryTitle(categoryTitle)
                        setAccordionData(updatedAccordionData);
                        setSelectedCategoryQuestions(updatedQuestions);
                    }
                }, (error) => {
                    console.error("API error:", error);
                });
            } else {
                setSelectedCategoryQuestions(category.questions);
            }
            setShowRightBar(false);
        } else {
            setSelectedCategoryQuestions([]);
            setShowRightBar(true);
            window.location.href = PAGE_HASH_LOCATION.faq
        }
    };


    const handleLogoClick = () => {
        setSelectedQuestion(null);
        setSearchText('');
        setShowStepsSection(true);
        setSelectedCategoryQuestions([]);
        setShowRightBar(true);
        setExpanded([]);
        setSearchResults([])
        setIsSearchSubmitted(false);
        window.location.href = PAGE_HASH_LOCATION.faq;
    };

    const capitalizeWords = (str) => {
        return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    const capitalizeFirstLetter = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const handleSearchChange = (search) => {
        setSearchText(search);
        setIsSearchSubmitted(true);

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        if (search.length > 0) {
            const timer = setTimeout(() => {
                fetchSearchResults(search);
            }, 1000);

            debounceTimerRef.current = timer;
        } else {
            setSearchResults([]);
            setIsSearchSubmitted(false);
        }
    };

    const fetchSearchResults = (searchString) => {
        if (searchString) {
            const successFunction = (response) => {
                if (response?.result === "SUCCESS") {
                    if (response.all_faqs && Array.isArray(response.all_faqs)) {
                        const filteredResults = response.all_faqs.filter(faq => faq.question.toLowerCase().includes(searchString.toLowerCase()));
                        setSearchResults(filteredResults);
                    } else {
                        setSearchResults([]);
                    }
                } else {
                    setSearchResults([]);
                }
            };

            const failureFunction = (error) => {
                console.log(error);
            };
            searchFaqs({keyword: searchString}, successFunction, failureFunction, {
                method: 'POST',
            });
        } else {
            setSearchResults([]);
            setIsSearchSubmitted(false);
        }
    };


    const popularTopics = [{
        image: form_builder,
        title: "form builder",
        description: "Learn how to build forms, explore question types, and master essential functions.",
        alt: "forms-app"
    }, {
        image: quiz_builder,
        title: "quiz builder",
        description: "Discover how to create quizzes, use different question formats, and assign correct answers.",
        alt: "quiz"
    }, {
        image: premium_builder,
        title: "premium",
        description: "Learn how to access premium features and streamline the payment process.",
        alt: "premium"
    }, {
        image: dashboard_builder,
        title: "dashboard",
        description: "Understand how to navigate the dashboard, explore its contents, and utilize it effectively.",
        alt: "dashboard"
    }, {
        image: settings_builder,
        title: "settings control",
        description: "Manage and adjust form settings, and learn about each option available.",
        alt: "settings"
    }, {
        image: collaborator_builder,
        title: "collaborator",
        description: "Learn how to add collaborators, manage roles, and work efficiently together.",
        alt: "collaborator"
    }];

    return (<>
        <div className="pc-view">
            <div className="faq-container">
                <Card className="left-bar">
                    <div className="title-bar">
                        <img id="faq-logo" src={surveyheart1} alt="surveyheart-logo" onClick={handleLogoClick}/>
                        <h1 className="topic">Topics</h1>
                    </div>

                    <div className="dropdowns-content">
                        {accordionData.map((item, index) => (<div className="accordion-container" key={index}>
                            <div className="accordion-head" onClick={() => handleAccordionChange(index)}>
                                <span style={{flexGrow: 1}}>{capitalizeWords(item.category_name)}</span>
                                <img
                                    className="down-arrow"
                                    src={expanded.includes(index) ? up_gray : down_gray}
                                    alt={expanded.includes(index) ? "up-arrow" : "down-arrow"}
                                    style={{width: '8px', height: '8px'}}
                                />
                            </div>
                            {expanded.includes(index) && (<div className="accordion-details">
                                <ul className="custom-list">
                                    {item.questions && item.questions.length > 0 && (item.questions.map((question) => (
                                        <li
                                            key={question._id}
                                            onClick={() => {
                                                navigate(`#?id=${question._id}`);
                                                handleSubsectionClick(question);
                                            }}
                                            className={`subsection-link ${selectedQuestion && selectedQuestion._id === question._id && !selectedCategoryQuestions.includes(question) ? "highlight" : ""}`}
                                        >
                                            <img className="vector-icon" src={Vector}
                                                 alt="vector-icon"/>
                                            {capitalizeFirstLetter(question.question)}
                                        </li>)))}
                                </ul>
                            </div>)}
                        </div>))}
                    </div>

                    <Card className="contact-bar">
                        <p>For any queries or doubts, <br/> kindly reach us out.</p>
                        <MaterialButton
                            data={{
                                title: "Contact us",
                                buttonType: ButtonTypes.CONTAINED,
                                bg_color: '#1976D2',
                                fontSize: '14px',
                                customButtonContainerStyle: {
                                    margin: '',
                                    borderRadius: '50px',
                                    padding: '9px 15px',
                                    width: '120px',
                                    height: '35px'
                                }
                            }}
                            handleClick={handleContactClick}
                        />
                    </Card>
                </Card>

                {selectedQuestion && showStepsSection && (<div className="steps-section">
                    <div className="title-and-button">
                        <h2 className="ques-title">{capitalizeWords(selectedQuestion.question)}</h2>
                        <div className="copy-link-button">
                            <button className="button-style" onClick={handleCopyLink}>
                                <img src={link} alt="link icon" className="link-icon"/>
                                {copyStatus}
                            </button>
                        </div>
                    </div>
                    <br/>
                    {selectedQuestion.video_url && (<div className="video-container">
                        <div className="youtube" onClick={() => setShowVideo(true)}>
                            <div className="iframe-overlay"/>
                            <iframe
                                width="400"
                                height="250"
                                src={selectedQuestion.video_url.includes('youtu.be/') ? `${selectedQuestion.video_url.replace('youtu.be/', 'www.youtube.com/embed/').split('?')[0]}` : selectedQuestion.video_url.includes('www.youtube.com/watch?v=') ? `${selectedQuestion.video_url.replace('watch?v=', 'embed/').split('&')[0]}` : ''}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>

                        {showVideo && (<Provider store={appStore}>
                            <ImageViewerComponent
                                attachment={selectedQuestion.video_url.includes('youtu.be/') ? `${selectedQuestion.video_url.replace('youtu.be/', 'www.youtube.com/embed/').split('?')[0]}` : selectedQuestion.video_url.includes('www.youtube.com/watch?v=') ? `${selectedQuestion.video_url.replace('watch?v=', 'embed/').split('&')[0]}` : ''}
                                video={true}
                                close={() => setShowVideo(false)}
                            />
                        </Provider>)}
                    </div>)}

                    <div className="steps">
                        {['android_steps', 'web_steps', 'ios_steps'].map((deviceKey) => {
                            const deviceName = deviceKey.split('_')[0];
                            return (<React.Fragment key={deviceKey}>
                                <h3 className="device">{deviceName.charAt(0).toUpperCase() + deviceName.slice(1)}</h3>
                                <div className="step-list">
                                    {selectedQuestion.answer[deviceKey] ? (selectedQuestion.answer[deviceKey].map((step, index) => (
                                        <li key={index}>{step}</li>))) : (<li>No steps available for {deviceName}</li>)}
                                </div>
                            </React.Fragment>);
                        })}
                    </div>
                </div>)}

                {showRightBar && (<div className="rightbar" style={{display: "block", marginTop: '20px'}}>
                    {!isSearchSubmitted && <h2 className="FAQ">Frequently Asked Questions</h2>}
                    <div className={'search-function'}>
                        <SearchBaseComponent
                            value={searchText}
                            handleTextChange={handleSearchChange}
                            style={{border: "none"}}
                        />
                    </div>
                    {isSearchSubmitted && (<div className="search-results">
                        {searchResults?.length > 0 ? (searchResults?.map((question) => (
                            <div key={question._id} className="search-section">
                                <ul className="search-list">
                                    <li
                                        key={question._id}
                                        className={`search-item ${selectedQuestion && selectedQuestion.question === question.question ? 'highlight' : ''}`}
                                        onClick={() => handleSubsectionClick(question)}
                                    >
                                        <img src={Vector} alt="icon" className="vector-icon-small"/>
                                        <span>{capitalizeFirstLetter(question.question)}</span>
                                        <img src={right_path_arrow} alt="dropdown-icon"
                                             className="right-icon"/>
                                    </li>
                                </ul>
                            </div>))) : (<div className="no-results">
                            <img src={search_grey} alt="result icon"/>
                            <p>No results found</p>
                        </div>)}
                    </div>)}


                    {!isSearchSubmitted && (<>
                        <h2 className="popular-topic">Popular Topics</h2>
                        <div className={'topics'}>
                            <div className={'topics-grid'}>
                                {popularTopics.map((topic, index) => (<div className={'Builder'}
                                                                           key={index}
                                                                           onClick={() => handlePopularTopicClick(topic.title)}>
                                    <img src={topic.image} alt={topic.alt}
                                         style={{height: '48px', width: '48px', marginTop: '10px'}}
                                    />
                                    <h3>{capitalizeWords(topic.title)}</h3>
                                    <p className={'popular-topic-description'}>{topic.description}</p>
                                </div>))}
                            </div>
                        </div>
                    </>)}
                </div>)}
            </div>
        </div>

        {selectedCategoryQuestions.length > 0 && !showRightBar && (<div className="category-questions">
            <h3>{capitalizeWords(selectedCategoryTitle) || 'Category'}</h3>
            <ul style={{position: "relative", left: "70px", height: "49px"}}>
                {selectedCategoryQuestions.map((question) => (<li className={'category-list'} key={question._id}
                                                                  onClick={() => {
                                                                      navigate(`#?id=${question._id}`);
                                                                      handleSubsectionClick(question);
                                                                  }}
                >
                    <img className="vector-icon" src={Vector} alt="vector-icon"
                         style={{width: "12px", height: "12px", marginRight: "8px"}}/>
                    <span>{capitalizeFirstLetter(question.question)}</span>
                    <img src={right_path_arrow} alt="dropdown-icon" className="right-icon"/>
                </li>))}
            </ul>
        </div>)}
    </>);
};

export default Faq;